<template>

    <div>
        <div class="row">
            <div class="col-md-4">
                <AdminBlock title="Customer">
                    <dl>
                        <dt>
                            Current Customer
                        </dt>
                        <dd>
                            <a :href="generateCustomerRoute()">
                                {{ job.customer.name }}
                            </a>
                        </dd>
                    </dl>
                    <dl class="mb-0">
                        <dd class="mb-0">
                            <CustomerSelect
                                title="New Customer"
                                v-model="selectedCustomer"
                                remove-margin
                            />
                        </dd>
                    </dl>
                </AdminBlock>
            </div>
            <div class="col-md-4">
                <AdminBlock title="Contract">
                    <dl>
                        <dt>
                            Current Contract
                        </dt>
                        <dd>
                            <a :href="generateContractRoute()">
                                {{ job.contract.name }}
                            </a>
                        </dd>
                    </dl>
                    <dl class="mb-0">
                        <dd class="mb-0">
                            <ContractSelect
                                v-model="selectedContract"
                                :contract="selectedContract"
                                :customer="selectedCustomer"
                                title="New Contract"
                                remove-margin
                            />
                        </dd>
                    </dl>
                </AdminBlock>
            </div>
            <div class="col-md-4">
                <AdminBlock title="Vehicle">
                    <div class="row">
                        <div class="col-md-6">
                            <dl>
                                <dt>
                                    Current Vehicle
                                </dt>
                                <dd>
                                    <a :href="generateVehicleRoute()">
                                        {{ job.vehicle.reg }}
                                    </a>
                                </dd>
                            </dl>
                        </div>
                        <div class="col-md-6">
                            <dl>
                                <dt>
                                    Move {{ job.vehicle.reg }} to new Customer
                                </dt>
                                <dd>
                                    <input type="checkbox" v-model="moveVehicle" name="move_vehicle" id="move_vehicle">
                                </dd>
                            </dl>
                        </div>
                    </div>

                    <dl class="mb-0">
                        <dd class="mb-0">
                            <VehicleSelect
                                v-model="selectedVehicle"
                                :vehicle="selectedVehicle"
                                :customer="selectedCustomer"
                                title="New Vehicle"
                                remove-margin
                            />
                        </dd>
                    </dl>
                </AdminBlock>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <AdminBlock>
                    <div class="d-flex justify-content-end">
                        <div class="me-2">
                            <a :href="generateEditJobRoute()" class="btn btn-danger">
                                Cancel
                            </a>
                        </div>
                        <div class="">
                            <button type="button" @click="submitForm" class="btn btn-success">
                                Proceed
                            </button>
                        </div>
                    </div>
                </AdminBlock>
            </div>
        </div>
    </div>

</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";
import customerSelect from '@/components/movements/components/CustomerSelect.vue';
import contractSelect from '@/components/movements/components/ContractSelect.vue';
import vehicleSelect from '@/components/movements/components/VehicleSelect.vue';
import AdminBlock from "@/components/movements/components/AdminBlock.vue";

export default {

    components: {
        AdminBlock,
        customerSelect,
        contractSelect,
        vehicleSelect,
    },

    props: {
        job: {
            type: Object,
            required: true
        },
    },

    data () {
        return {
            selectedCustomer: this.job.customer,
            selectedContract: this.job.contract,
            selectedVehicle: this.job.vehicle,
            moveVehicle: false,
        }
    },

    methods: {
        generateFormMethod() {
            return route('api.movements.jobs.move.process', this.job);
        },
        generateCustomerRoute() {
            return route('movements.customers.show', this.job.customer);
        },
        generateContractRoute() {
            return route('movements.contracts.show', this.job.contract);
        },
        generateVehicleRoute() {
            return route('movements.vehicles.show', this.job.vehicle);
        },
        generateEditJobRoute() {
            return route('movements.jobs.edit', this.job);
        },
        submitForm() {
            if (!this.selectedCustomer?.id || !this.selectedContract?.id || !this.selectedVehicle?.id) {
                return Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Please select a new customer, contract and vehicle before proceeding',
                });
            }

            const data = new FormData();
            data.append('job_id', this.job.id);
            data.append('customer_id', this.selectedCustomer.id);
            data.append('contract_id', this.selectedContract.id);
            data.append('vehicle_id', this.selectedVehicle.id);
            data.append('move_vehicle', this.moveVehicle);

            axios.post(this.generateFormMethod(), data)
                .then(response => {

                    const redirectUrl = response.data.redirect_url;

                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'success',
                        confirmButtonText: 'Redirect Now',
                        confirmButtonColor: '#28a745',
                        html: `<p class="mb-0">${response.data.message}</p>`,
                        width: '700px',
                        timer: 3000,
                        timerProgressBar: true,
                    }).then(() => {
                        window.location.href = redirectUrl;
                    });
                })
                .catch(error => {

                    const errorMessages = error.response?.data?.errors || {};
                    const allErrors = Object.values(errorMessages)
                        .flat()
                        .map(msg => `<p class="mb-0">${msg}</p>`)
                        .join('');

                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        icon: 'error',
                        title: "Error Updating Job",
                        html: allErrors || 'An error occurred',
                        timer: 3000,
                        width: '600px',
                        showConfirmButton: false,
                    });

                });

        }
    },

    watch: {
        selectedCustomer: function (val, oldVal) {
            if (val !== oldVal) {
                this.selectedContract = null;
                this.selectedVehicle = null;
            }
        }
    }
}
</script>
